// ---------------------------------------------------------------------------
// SINGLE SOURCE OF TRUTH for business + legal details used across the site.
//
// >>> ACTION REQUIRED BEFORE SUBMITTING TO A PAYMENT GATEWAY <<<
// Replace every value marked TODO with your real registered details.
// Payment gateways (Razorpay / PayU / Cashfree / Instamojo) verify these
// against your bank account and GST/registration documents.
// ---------------------------------------------------------------------------

export const BUSINESS = {
  // Trading / brand name
  brand: "Rango E-Cycles",

  // Registered legal entity name, as on the bank account and GST certificate.
  legalName: "Rango E-Cycles",

  entityType: "Sole Proprietorship",

  gstin: "10EWFPK8885N1ZU",
  cin: "",

  operatingAddress:
    "Near Mathiapur, Math Road, Ashopur, Khagaul, Patna, Bihar 801505, India",

  registeredAddress:
    "Flat No. 705, A Block, R N City, R K Puram, Danapur Khagaul Road, Ashopur, Near Blue Bells Academy, Danapur, Patna, Bihar 801503, India",

  email: "rangocycles@gmail.com",
  phone: "+91 76671 89733",
  phoneRaw: "917667189733",
  whatsapp: "917667189733",

  supportHours: "Everyday, 10:00 AM to 8:00 PM IST",

  currency: "INR",
  currencyLabel: "Indian Rupee (INR / ₹)",

  // Used in the "last updated" line on every policy page.
  policyLastUpdated: "30 August 2026",

  serviceArea: "Patna and adjoining districts of Bihar, India",

  jurisdiction: "the courts at Patna, Bihar, India",

  // Booking advance shown in payment terms.
  bookingAdvanceMin: "₹2,000",
};

export const LEGAL_ROUTES = [
  { path: "/terms", label: "Terms of Service" },
  { path: "/privacy", label: "Privacy Policy" },
  { path: "/refund-policy", label: "Refund & Cancellation" },
  { path: "/shipping-policy", label: "Shipping & Delivery" },
  { path: "/warranty-returns", label: "Warranty & Returns" },
];

export default BUSINESS;
